// extracted by mini-css-extract-plugin
module.exports = {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__1fT5e","subTitleBold":"BoxSubTitle_subTitleBold__2xO5o"};